import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl(isDayTrading) {
  return isDayTrading
    ? 'v1/stock/odt/stock-tradable/discovery/'
    : 'v1/stock/discovery/group/member/';
}

/**
 * @param {string} url
 * @param {string} groupCode
 * @param {number} pageSize
 * @param {Record<string, any>} extraParams
 */
function callbackFetch(url, groupCode, pageSize, extraParams) {
  return async ({ pageParam = 1 }) => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url, {
        params: {
          group_code: groupCode,
          page: pageParam,
          page_size: pageSize,
          ...(extraParams || {}),
        },
      });

      return res.data;
    } catch (err) {
      const resp = err?.response?.data;
      errorLogger('ERROR_API', resp?.err_message || err.message);
      throw resp || err;
    }
  };
}

/**
 * @param {{ groupCode: string, pageSize?: number, isDayTrading?: boolean, params?: Record<string, any> }} args
 */
export default function fetch(args) {
  const { groupCode, pageSize = 50, isDayTrading = false, params } = args || {};
  const url = getUrl(isDayTrading);

  return {
    cb: callbackFetch(url, groupCode, pageSize, params),
    key: [url, groupCode, pageSize, params],
  };
}
